import { render } from "./TabOrderList.vue?vue&type=template&id=196de832"
import script from "./TabOrderList.js?vue&type=script&lang=js"
export * from "./TabOrderList.js?vue&type=script&lang=js"

import "./TabOrderList.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__